import { render } from "./BootstrapModal.vue?vue&type=template&id=872aeb0a&scoped=true"
import script from "./BootstrapModal.vue?vue&type=script&lang=js"
export * from "./BootstrapModal.vue?vue&type=script&lang=js"

import "./BootstrapModal.vue?vue&type=style&index=0&id=872aeb0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-872aeb0a"]])

export default __exports__